/* eslint-disable */


// function getCookies() {
//     var c = document.cookie, v = 0, cookies = {};
//     if (document.cookie.match(/^\s*\$Version=(?:"1"|1);\s*(.*)/)) {
//         c = RegExp.$1;
//         v = 1;
//     }
//     if (v === 0) {
//         c.split(/[,;]/).map(function(cookie) {
//             var parts = cookie.split(/=/, 2),
//                 name = decodeURIComponent(parts[0].trimLeft()),
//                 value = parts.length > 1 ? decodeURIComponent(parts[1].trimRight()) : null;
//             cookies[name] = value;
//         });
//     } else {
//         c.match(/(?:^|\s+)([!#$%&'*+\-.0-9A-Z^`a-z|~]+)=([!#$%&'*+\-.0-9A-Z^`a-z|~]*|"(?:[\x20-\x7E\x80\xFF]|\\[\x00-\x7F])*")(?=\s*[,;]|$)/g).map(function(s0: any, s1: any) {
//             var name = s0,
//                 value = s1.charAt(0) === '"'
//                           ? s1.substr(1, -1).replace(/\\(.)/g, "$1")
//                           : s1;
//             cookies[name] = value;
//         });
//     }
//     return cookies;
// }


// export const all = getCookies();

// export function getCookie(name: string) {
//     return all[name];
// }


export function setCookie(name: string, value: string, days: number) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export function getCookie(name: string) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) {
            return decodeURIComponent(c.substring(nameEQ.length,c.length));
        }
    }
    return null;
}
export function eraseCookie(name: string) {
    document.cookie = name+'=; path=/; Max-Age=-99999999;';  
}
